import React from 'react'
import PropTypes from 'prop-types'

import drawerBack from 'resources/drawer_icon_back.png'

const InvoiceHistory = () => {
  return (<div>Invoice History</div>)
}

const ReferencedJobs = () => {
  return (<div>Invoice History</div>)
}

export default class ReferenceInfoSlider extends React.Component {

  static propTypes = {
    open: PropTypes.bool.isRequired,
    onBackClicked: PropTypes.func.isRequired
  }

  render() {
    if (!this.props.open) {
      return null
    }
    return (
      <div style={styles.container}>
        <div style={styles.top}>
          <img src={drawerBack}
            style={styles.drawer}
            title='Hide Reference Info'
            width={24} height={24}
            onClick={this.props.onBackClicked} />
          <div style={styles.heading}>Reference Info</div>
          <div style={{ width: 24 }}/>
        </div>
        <div style={styles.content}>
          <InvoiceHistory />
          <ReferencedJobs />
        </div>
      </div>
    )
  }

}

const styles = {
  container: {
    width: 400,
    height: 603,
    position: 'absolute',
    background: '#fff',
    boxShadow: '6px 0 18px 0 rgba(0, 0, 0, 0.14)'
  },
  drawer: {
    cursor: 'pointer'
  },
  top: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    margin: 12,
    justifyContent: 'space-between'
  },
  heading: {
    fontSize: 24,
    color: '#000'
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 64,
    marginLeft: 24,
    marginRight: 24
  }
}



// WEBPACK FOOTER //
// ./src/billing/invoices/ReferenceInfoSlider.js